import gql from 'graphql-tag';

import client from '../graphqlAPI';

// Field selection covers both call sites: the plate-strip list (which only reads
// name/subject/isActive/updatedAt/variables) and the detail/editor screens keyed
// by a single scope+language, which additionally need every field the editor
// (EmailTemplateEditor.jsx) round-trips unchanged into editEmailTemplate -
// preheader/htmlContent/textContent/sampleData plus needsReview/isActive/source/
// appName, which the mutation would otherwise silently reset to its defaults if
// omitted. There is no separate single-template query in the schema.
//
// `revisions` is metadata only - author and savedAt, no content. Without it the
// version-history panel (EmailRevisionHistory.jsx) had nothing to list until the
// first save of a session, because only the edit and restore mutations returned
// the array. The per-revision content is deliberately NOT fetched: ten
// revisions of a 14KB template would be 140KB on every template open, and
// nothing on these screens reads it - restore is by index, server-side.
const GET_EMAIL_TEMPLATES_LIST = gql`
query getEmailTemplates($language: String, $scope: String, $appName: String, $isActive: Boolean, $search: String, $from: Int, $to: Int, $sortingField: String, $sortingType: Int, $getTotal: Boolean) {
  getEmailTemplates(language: $language, scope: $scope, appName: $appName, isActive: $isActive, search: $search, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType, getTotal: $getTotal) {
    isAuth
    total
    error
    templates {
      _id
      templateId
      name
      language
      scope
      subject
      preheader
      htmlContent
      textContent
      sampleData
      needsReview
      isActive
      source
      appName
      updatedAt
      variables
      # null for every hand-authored template, which is all 78 live ones. When
      # it is set, the editor opens the block builder instead of the cell and
      # HTML editors — the switch is on this field and never on a flag.
      blocks
      revisions {
        author
        savedAt
      }
    }
  }
}
`;

const getEmailTemplatesList = async (variables) => {
  try {
    const result = await client.query({
      query: GET_EMAIL_TEMPLATES_LIST,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getEmailTemplates: templatesData } } = result;

    if (templatesData) {
      return templatesData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getEmailTemplatesList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getEmailTemplatesList Error: ${error}`);
    return null;
  }
};

export default getEmailTemplatesList;
